import { render, staticRenderFns } from "./giacomo-conterno.vue?vue&type=template&id=3a37d890&scoped=true"
import script from "./giacomo-conterno.vue?vue&type=script&lang=js"
export * from "./giacomo-conterno.vue?vue&type=script&lang=js"
import style0 from "./giacomo-conterno.vue?vue&type=style&index=0&id=3a37d890&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a37d890",
  null
  
)

export default component.exports